module.exports = __webpack_public_path__ + "static/media/red-hat-fuse-online-logo.543c81df.png";